import {Base,Axios} from "@/api/Base"

export class EmployeeEntryRecordNewJoinReport extends Base {
    path = "employeeEntryRecord/newJoinReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}